<template>
  <div id="app">
    <section>
        <b-field label="Ваше имя">
            <b-input v-model="user.name"></b-input>
        </b-field>

        <b-field label="Электропочта">
            <b-input type="email"
              v-model="user.email"
              disabled
            >
            </b-input>
        </b-field>

        <b-field label="Юзернейм">
            <b-input v-model="user.username" maxlength="30"></b-input>
        </b-field>

        <b-field label="Пароль">
            <b-input type="password"
              v-model="user.password" password-reveal>
            </b-input>
        </b-field>

        <b-field label="О игроке">
            <b-input maxlength="200" type="textarea" v-model="user.about"></b-input>
        </b-field>

        <input type="file" accept="image/png, image/jpeg" v-on:change="appendAvatar($event)">

        <button type="button" class="button is-success" v-on:click="updateMe()">Сохранить</button>
    </section>
  </div>
</template>

<script>
import UserService from '../services/UserService'

export default {
  data() {
    return {
      user: {
      },
      avatar: ''
    }
  },
  mounted() {
    this.loadMe()
  },
  methods: {
    async loadMe() {
      const resp = await UserService.me() 
      this.user = resp.data
    },
    async updateMe() {
      const req = {}
      if (!!this.avatar) {
        this.user.avatar = this.avatar
      } else {
        this.user.avatar = false
      }
      await UserService.update(this.user)
    },
    async appendAvatar(e) {
      this.avatar = e.target.files[0]
    }
  },
}
</script>

<style scoped>
</style>
